import firebase from 'firebase';
var axios = require('axios');
//var Firebase = require('firebase');
//var gamesD = new Firebase('https://project-3261473790845899779.firebaseio.com/logs/games');


module.exports.logMapClick = function(game, map) {
 var mapCount;
 console.log(game);
 console.log(map);
 firebase.database().ref('logs/games/' + game + "/" + map).once('value').then(function(snapshot) {
    var obj = snapshot.val();
    mapCount = obj.count;
    mapCount++;
    firebase.database().ref('logs/games/' + game + "/" + map).set({
    count: mapCount
      });
   });
 };

 module.exports.logStratSave = function() {
  var stratSaveCount;
  firebase.database().ref('logs/strats').once('value').then(function(snapshot) {
     var obj = snapshot.val();
     stratSaveCount = obj.count;
     stratSaveCount++;
     firebase.database().ref('logs/strats').set({
     count: stratSaveCount
       });
    });
  };



// WEBPACK FOOTER //
// ./src/app/actions/log.js